import { blupayApi } from "../api/client";

export const routingService = {
  async listRules() {
    const { data } = await blupayApi.get("/routing/rules");
    return data;
  },

  async createRule(payload) {
    const { data } = await blupayApi.post("/routing/rules", payload);
    return data;
  },

  async updateRule(ruleId, payload) {
    const { data } = await blupayApi.patch(
      `/routing/rules/${ruleId}`,
      payload
    );
    return data;
  },

  async listCapabilities() {
    const { data } = await blupayApi.get("/routing/capabilities");
    return data;
  },

  async createCapability(payload) {
    const { data } = await blupayApi.post(
      "/routing/capabilities",
      payload
    );
    return data;
  },

  async updateCapability(capabilityId, payload) {
    const { data } = await blupayApi.patch(
      `/routing/capabilities/${capabilityId}`,
      payload
    );
    return data;
  },

  async selectRoute(payload) {
    const { data } = await blupayApi.post(
      "/routing/select-route",
      payload
    );
    return data;
  },

  async createRoutingDecision(transferId, payload) {
    const { data } = await blupayApi.post(
      `/routing/decisions/from-rule/${transferId}`,
      payload
    );
    return data;
  },
};